/** Versafy AI App Store listing; null until configured. */
export function getShopifyAppListingUrl(): string | null {
  return process.env.NEXT_PUBLIC_SHOPIFY_APP_LISTING_URL || null
}
